import React, { useEffect, useState } from 'react';
import './App.css';
import Board, { BlockViewModel } from './Board';
import { Keyboard } from './Keyboard';
import Block from './Block';
import { clock, ClockControl } from './model/Clock';
import { initialGameState } from './GameStateManager';

const gameState = initialGameState();

function App() {
  const [, setForceRenderCounter] = useState(0);
  const forceRender = () => setForceRenderCounter((new Date()).getTime());

  const ticksPerSecond = 20;

  useEffect(() => {
    gameState.onStateChange(() => {console.log('sc'); forceRender()});
    const keyboard = new Keyboard().install();

    let tickCount = 0;
    let mustRestartTimer = true;
    clock((clockControl: ClockControl) => {
      if (keyboard.consumeKeyPress(Keyboard.KEY_ESC)) {
        gameState.togglePause();
      }

      gameState.maybeInsertNewBlock();

      // must come after pause toggle and after insert block, as both may change the outcome of shouldLoopRun
      if (!gameState.shouldLoopRun()) {
        return;
      }

      tickCount += 1;
      console.log(`tick ${tickCount}`);
      const keyDown = keyboard.consumeKeyPress(Keyboard.KEY_DOWN);
      if (tickCount % ticksPerSecond === 0 || keyDown) {
        tickCount = 0;

        const {removedRows} = gameState.stepDown();
        mustRestartTimer = removedRows;
      }

      const keyCode = keyboard.consumeKeyPress(Keyboard.KEY_LEFT, Keyboard.KEY_RIGHT);
      if (keyCode) {
        if (!gameState.moveSideways(keyCode === Keyboard.KEY_LEFT ? -1 : 1)) {
          keyboard.unconsumeKeyPress(keyCode);
        }
      }

      const keyUp = keyboard.consumeKeyPress(Keyboard.KEY_UP);
      if (keyUp) {
        gameState.rotateBlock();
      }

      const keySpace = keyboard.consumeKeyPress(Keyboard.KEY_SPACE);
      if (keySpace) {
        if (gameState.zoomDown()) {
          tickCount = -1;
        }
      }

      if (mustRestartTimer) {
        mustRestartTimer = false;
        console.log(`level ${gameState.state.scoring.getLevel()}`);
        console.log(`secondsPerLine ${gameState.state.scoring.getSecondsPerLine()}`);
        clockControl.setInterval(gameState.state.scoring.getSecondsPerLine() * 1000 / ticksPerSecond);
      }
    });
  }, []);

  const blockViewModels: BlockViewModel[] = gameState.state.currentBlock ? gameState.state.placedBlocks.concat([gameState.state.currentBlock]) : gameState.state.placedBlocks;

  const previewBlock: BlockViewModel = {...gameState.nextBlockViewModel(), x: 1};

  return (
    <div className={`-game-over-${gameState.state.gameOver ? 'true': 'false'} -paused-${gameState.state.paused ? 'true' : 'false'}`}>
      <div className="game">
        <div className="game__board">
          <Board width={10} height={17} blockViewModels={blockViewModels}></Board>
        </div>
        <div className="game__preview">
          <Board width={5} height={2} blockViewModels={[previewBlock]}></Board>
        </div>
        <div className="game__numbers">
          <div className="number">
            <div className="number__label">
              Rows Cleared
            </div>
            <div className="number__value">
              {gameState.state.scoring.getNumberOfClearedRows()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
